import React from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './Dots.module.css';

const Dots = React.forwardRef(function Dots(
  { total, active, onSelect, className, ...rest },
  ref
) {
  return (
    <div ref={ref} className={cn(styles.root, className)} {...rest}>
      {Array.from({ length: total }, (_, i) => {
        const isActive = i === active;
        const dotClass = cn(styles.dot, isActive && styles.dotActive);
        if (onSelect) {
          return (
            <button
              key={i}
              type='button'
              className={dotClass}
              aria-label={`Ir para slide ${i + 1}`}
              aria-current={isActive}
              onClick={() => onSelect(i)}
            />
          );
        }
        return <span key={i} className={dotClass} />;
      })}
    </div>
  );
});

Dots.propTypes = {
  total: PropTypes.number.isRequired,
  active: PropTypes.number.isRequired,
  onSelect: PropTypes.func,
  className: PropTypes.string
};

export default Dots;
